const e = ["file", "folder"];
export {
  e as ASSET_VARIANTS
};
//# sourceMappingURL=Asset.types.js.map
